"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcPropertyUnits = class UcPropertyUnits extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_7920_getActionArgs($event) {
        return {
            name: "PropertyUnitEditor",
            props: {
                mode: "add",
                parent: this.parent,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2585509888553580_emit_7924_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_2585509888553580_close_7923_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_2585509888553580_showModal_7922_getActionArgs($event) {
        return {
            name: "PropertyUnitEditor",
            props: {
                parent: this.parent,
                item: $event.scope.item,
            },
        };
    }
    async evh_2585509888553580_clickPreventStop(event, scope) {
        return await this.actions.evh_2585509888553580_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7918 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7917 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7918,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7917],
        });
        const act_8320016629450276_showModal_7920 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_7920_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_7919 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_7920,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_7919],
        });
        const act_2585509888553580_emit_7924 = new core_1.actions.EmitAction({
            actionArgs: this.act_2585509888553580_emit_7924_getActionArgs,
            events: [],
        });
        const evh_2585509888553580_close_7923 = new core_1.actions.EventHandlerImpl({
            action: act_2585509888553580_emit_7924,
            event: "close",
            when: this.evh_2585509888553580_close_7923_getWhen,
            displayName: "emit",
        });
        const act_2585509888553580_showModal_7922 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2585509888553580_showModal_7922_getActionArgs,
            events: [evh_2585509888553580_close_7923],
        });
        const evh_2585509888553580_clickPreventStop_7921 = new core_1.actions.EventHandlerImpl({
            action: act_2585509888553580_showModal_7922,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_2585509888553580_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2585509888553580_clickPreventStop_7921],
        });
        return {
            act_7315092382398562_reloadComponentData_7918,
            evh_7315092382398562_reload_7917,
            evh_7315092382398562_reload,
            act_8320016629450276_showModal_7920,
            evh_8320016629450276_clickPreventStop_7919,
            evh_8320016629450276_clickPreventStop,
            act_2585509888553580_emit_7924,
            evh_2585509888553580_close_7923,
            act_2585509888553580_showModal_7922,
            evh_2585509888553580_clickPreventStop_7921,
            evh_2585509888553580_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcPropertyUnits.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcPropertyUnits.prototype, "onParent", null);
UcPropertyUnits = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcPropertyUnits);
exports.default = UcPropertyUnits;
vue_property_decorator_1.Vue.component("UcPropertyUnits", UcPropertyUnits);
